import { localStorage as safeLocalStorage } from 'utils/browserStorage';
import { JobProps } from "utils/types";
import React, {FC, useState} from "react";
import styles from "../ShiftDetail.module.scss";
import {exitReact} from "../../../../utils";
import useActionApi from "../../../../hooks/useActionApi";
import Api from "../../../../api";
import FixedLoader from "components/FixedLoader/FixedLoader";
import clsx from "clsx";
import {JOB_STATUSES} from "../ShiftDetailPage";
import dayjs from "dayjs";
import {ShiftPopup} from "./index";
import Popup from "../../../../components/Popup";
import {StyledButton} from "components/Buttons/DefaultButton/DefaultButton.styles";

// @ts-ignore
const TempStars = window.TempStars

export function handleCompleteShiftSuccess({
    jobId,
    history,
    trackData,
    tempStars = (window as any).TempStars,
    storage = safeLocalStorage,
}: {
    jobId: number | string;
    history: { push: (path: string) => void };
    trackData: any;
    tempStars?: any;
    storage?: Storage;
}) {
    tempStars?.Analytics?.track?.('mark shift as completed', trackData);

    const normalizedJobId = Number(jobId);
    if (Number.isInteger(normalizedJobId) && normalizedJobId > 0) {
        storage.setItem('pendingFeedbackJobId', String(normalizedJobId));
    }

    history.push('loading')
    tempStars?.App?.goReact?.('hygienistHome')
}

const CompleteShiftModal:FC<{
    job: JobProps,
    history: any,
    trackData: any,
}> = (
    {
        job,
        history,
        trackData,
    }) => {
    const [isOpenCompleteShiftModal, setIsOpenCompleteShiftModal] = useState<boolean>(false);
    const [completeError, setCompleteError] = useState<string | null>(null);

    const [completeJobLoading, , completeJob] = useActionApi({
        apiMethod: Api.completeJob,
        onSuccess: () => {
            handleCompleteShiftSuccess({ jobId: job.id, history, trackData, tempStars: TempStars });
        },
        onError: (err: any) => {
            const message = err?.message || err?.response?.data?.message || 'Unable to complete this shift. Please try again.';
            setCompleteError(message);
        },
    });

    const isTodayOrBefore = !dayjs(job.startDate).isAfter(dayjs())

    const onCompleteShift = async () => {
        setIsOpenCompleteShiftModal(false)
        setCompleteError(null)
        await completeJob(job.id)
    }

    return (JOB_STATUSES.CONFIRMED === job.status && isTodayOrBefore ? <>
        <Popup opened={isOpenCompleteShiftModal} onClose={() => setIsOpenCompleteShiftModal(false)}>
            <ShiftPopup
                title={'Shift Completed?'}
                submit={'Mark as Complete'}
                close={'Cancel'}
                job={job}
                onClose={() => setIsOpenCompleteShiftModal(false)}
                onSubmit={onCompleteShift}
            />
        </Popup>

        {completeError && (
            <div style={{ color: '#d32f2f', background: '#fdecea', borderRadius: 8, padding: '10px 14px', margin: '8px 0', fontSize: 14, textAlign: 'center' }}>
                {completeError}
            </div>
        )}

        <StyledButton
            className={clsx(styles.completeButton)}
            variant="contained"
            color="primary"
            size="large"
            id="complete-button"
            onClick={() => setIsOpenCompleteShiftModal(true)}
        >
            Mark Shift Completed
        </StyledButton>

        <FixedLoader
            loading={completeJobLoading}
        />
    </> : null)
}

export default CompleteShiftModal;